import React, { useEffect, useState } from "react";
import { API, UPLOADS } from "./../../config/api";
import HorizontalAds from "../../Admin/Pages/HorizontalAds";
export default function UserTransaction() {
  const [transactions, setTransactions] = useState([]);

  const user = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 30;
  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      const res = await fetch(
        `${API.BASE_URL}/payment.php?action=payment_history&user_id=${user.id}`,
      );

      const data = await res.json();

      if (data.status) {
        setTransactions(data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [fromDate, toDate, statusFilter]);

  const getStatusStyle = (status) => {
    switch (status) {
      case "Success":
        return { background: "#dcfce7", color: "#166534" };
      case "Failed":
        return { background: "#fee2e2", color: "#991b1b" };
      case "Cancelled":
        return { background: "#fee2e2", color: "#991b1b" };
      default:
        return { background: "#fef9c3", color: "#854d0e" };
    }
  };

  const filteredTransactions = transactions.filter((item) => {
    const itemDate = new Date(item.created_at);

    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;

    const statusMatch = statusFilter ? item.status === statusFilter : true;

    const fromMatch = from ? itemDate >= from : true;
    const toMatch = to ? itemDate <= to : true;

    return statusMatch && fromMatch && toMatch;
  });
  const paginatedData = filteredTransactions.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  return (
    <div className="txn-page">
      <div className="txn-container">
        <div className="txn-header">
          <h2>Transaction History</h2>
          <p>All your payments in one place</p>
        </div>
        <div className="txn-filters-inline">
          <div className="filter-item">
            <label>From</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="filter-item">
            <label>To</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <div className="filter-item">
            <label>Status</label>
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All</option>
              <option value="Success">Success</option>
              <option value="Failed">Failed</option>
            </select>
          </div>

          <button
            className="txn-clear-btn"
            onClick={() => {
              setFromDate("");
              setToDate("");
              setStatusFilter("");
            }}
          >
            Clear
          </button>
        </div>
        {paginatedData.length === 0 ? (
          <div className="txn-empty">No transactions found</div>
        ) : (
          <div className="txn-table-card">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Date</th>

                  <th>Txn ID</th>
                  {/* <th>PayU ID</th> */}
                  <th>Amount</th>
                  {/* <th>Gateway</th>
                  <th>Mode</th> */}
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {paginatedData.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>{new Date(item.created_at).toLocaleString()}</td>

                    <td className="muted">{item.txnid}</td>
                    {/* <td>{item.mihpayid || "-"}</td> */}
                    <td className="amount">₹ {item.amount}</td>
                    {/* <td>{item.payment_gateway}</td>
                    <td>{item.payment_mode || "-"}</td> */}
                    <td>
                      <span
                        className="status"
                        style={getStatusStyle(item.status)}
                      >
                        {item.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="txn-pagination">
              <button
                onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                disabled={currentPage === 1}
              >
                Prev
              </button>

              <span>
                Page {currentPage} of{" "}
                {Math.ceil(filteredTransactions.length / itemsPerPage)}
              </span>

              <button
                onClick={() =>
                  setCurrentPage((p) =>
                    p < Math.ceil(filteredTransactions.length / itemsPerPage)
                      ? p + 1
                      : p,
                  )
                }
                disabled={
                  currentPage ===
                  Math.ceil(filteredTransactions.length / itemsPerPage)
                }
              >
                Next
              </button>
            </div>
          </div>
        )}
        <HorizontalAds />
      </div>

      {/* CSS */}
      <style>{`
       .txn-page {
  background: #f8fafc;
  min-height: 100vh;
  padding: 30px 0;
 
}

.txn-container {
  max-width: 1100px;
  margin: auto;
  padding: 0 15px;
}

.txn-header {
  margin-bottom: 20px;
}

.txn-header h2 {
  margin: 0;
  font-size: 24px;
  color: #111827;
}

.txn-header p {
  margin: 5px 0 0;
  color: #6b7280;
  font-size: 14px;
}

/* ================= TABLE ================= */

.txn-table-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 850px;
}

thead {
  background: #f1f5f9;
}

th, td {
  padding: 12px 14px;
  text-align: left;
  font-size: 14px;
  border-bottom: 1px solid #eef2f7;
  color: #374151;
}

tr:hover {
  background: #f9fafb;
}

.amount {
  font-weight: 600;
  color: #11867f;
}

.muted {
  font-size: 12px;
  color: #6b7280;
}

.status {
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
}

/* ================= EMPTY ================= */

.txn-empty {
  text-align: center;
  padding: 50px;
  background: #fff;
  border-radius: 12px;
  color: #6b7280;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

/* ================= FILTER BAR (IMPORTANT FIX) ================= */

.txn-filters-inline {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;

  flex-wrap: nowrap; /* ❗ force single row */

  background: #fff;
  padding: 12px 14px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  margin-bottom: 15px;

  overflow-x: auto; /* scroll on small screens */
}

/* filter fields */
.filter-item {
  display: flex;
  flex-direction:row !important;
  gap: 4px;
  align-items:center;
}

.filter-item label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
  padding-right:10px;
}

/* inputs */
.filter-item input,
.filter-item select {
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;

  min-width: 140px;
  max-width: 140px;

  outline: none;
  background: #fff;
  transition: 0.2s;
}

.filter-item input:focus,
.filter-item select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,0.15);
}

/* clear button */
.txn-clear-btn {
  height: 38px;
  padding: 0 14px;
  border: none;
  border-radius: 8px;
  background: #ef4444;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  white-space: nowrap;
  transition: 0.2s;
}

.txn-clear-btn:hover {
  background: #dc2626;
}

/* ================= RESPONSIVE ================= */

@media (max-width: 600px) {
  .txn-filters-inline {
    gap: 10px;
  }

  .filter-item input,
  .filter-item select {
    min-width: 120px;
    max-width: 120px;
  }
}
  .txn-filters-inline {
  display: flex;
  align-items: flex-end; /* aligns inputs properly */
  gap: 12px;
  flex-wrap: nowrap;
  background: #fff;
  padding: 12px 14px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  margin-bottom: 15px;
  overflow-x: auto;
}

/* ❗ CHANGE HERE: make label + input horizontal */
.filter-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* label still above input (but compact) */
.filter-item label {
  font-size: 11px;
  color: #6b7280;
  font-weight: 600;
  margin-left: 2px;
}

/* inputs */
.filter-item input,
.filter-item select {
  padding: 9px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;

  width: 140px;   /* fixed width for row alignment */
  min-width: 140px;

  outline: none;
  background: #fff;
}

/* focus */
.filter-item input:focus,
.filter-item select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59,130,246,0.15);
}

/* clear button aligned center */
.txn-clear-btn {
  height: 38px;
  padding: 0 14px;
  border: none;
  border-radius: 8px;
  background: #ef4444;
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
}
  .txn-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 15px;
  margin-bottom: 15px;
}

.txn-pagination button {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  background: #11867f;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
}

.txn-pagination button:disabled {
  background: #94a3b8;
  cursor: not-allowed;
}

.txn-pagination span {
  font-size: 14px;
  color: #374151;
  font-weight: 600;
}
      `}</style>
    </div>
  );
}
